import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Editorial preview card for planning/highlight/guide index pages.
export const PreviewCard = ({ to, image, eyebrow, title, text, meta, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="group flex flex-col overflow-hidden rounded-2xl border border-stone-line bg-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
  >
    <div className="relative aspect-[16/10] overflow-hidden">
      <img
        src={image}
        alt={title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      {eyebrow && (
        <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-charcoal backdrop-blur">
          {eyebrow}
        </span>
      )}
    </div>
    <div className="flex flex-1 flex-col p-6">
      {meta && <div className="mb-2 text-xs uppercase tracking-wider text-slatey">{meta}</div>}
      <h3 className="font-serif text-2xl font-medium leading-snug text-charcoal transition-colors group-hover:text-gold-dark">
        {title}
      </h3>
      {text && <p className="mt-2 flex-1 text-[15px] font-light leading-relaxed text-slatey">{text}</p>}
      <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-gold-dark">
        Read more
        <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
      </span>
    </div>
  </Link>
);

export default PreviewCard;
